import React, { useState } from 'react';
import SmsThreadList from '../../shared/components/SmsThreadList';
import * as styles from '../styles/rightPane.module.scss';
import CallHistoryList from './CallHistoryList';
import FilterList from './FilterList';

const filters = [
  {
    name: 'Call History',
    value: 'callHistory' as const,
  },
  {
    name: 'SMS',
    value: 'sms' as const,
  },
];

const RightPane: React.FC = () => {
  const [selectedPane, setSelectedPane] = useState<'callHistory' | 'sms'>(
    'callHistory',
  );

  return (
    <>
      <FilterList
        selectedFilter={selectedPane}
        filters={filters}
        onSelected={(filter) => {
          setSelectedPane(filter);
        }}
      />
      <div className={styles.container}>
        {selectedPane === 'callHistory' ? (
          <CallHistoryList />
        ) : (
          <SmsThreadList />
        )}
      </div>
    </>
  );
};

export default React.memo(RightPane);
